/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * The settings search query, shared between the v2 settings menu (which owns
 * the search box) and the Settings overview (which filters its cards by it).
 * Null outside SettingsLayoutV2, so classic and any page rendered without the
 * layout keep their own behaviour.
 */

import { createContext, useContext } from "react";

const SettingsQueryContext = createContext(null);

export const SettingsQueryProvider = SettingsQueryContext.Provider;

/** { query, setQuery } inside the v2 settings layout, else null. */
export function useSettingsQuery() {
  return useContext(SettingsQueryContext);
}
